export default function () {
  return {
    title: '分页设置',
    type: 'group',
    display: 'accordion',
    collapsed: true,
    items: [
      {
        name: 'paging',
        title: '是否开启',
        display: 'inline',
        initialValue: true,
        defaultValue: true,
        // supportVariable: true,
        setter: 'BoolSetter',
      },
      {
        name: 'pageSizeList',
        title: '每页显示选择器可选值',
        display: 'inline',
        initialValue: [10, 20, 50],
        defaultValue: [10, 20, 50],
        disabled() {
          return !this.getProps().getPropValue('paging');
        },
        setter: 'JsonSetter',
      },
      {
        name: 'defaultPageSize',
        title: '默认的每页条数',
        tip: '优先展示接口配置的数据',
        display: 'inline',
        disabled() {
          return !this.getProps().getPropValue('paging');
        },
        setter: 'NumberSetter',
      },
    ],
  };
}
